import { Box, Typography, useTheme } from "@mui/material";
import React from "react";

export default function AuthFooter() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        height: "50px",
        position: "fixed",
        maxWidth: "450px",
        bottom: "0px",
        zIndex: 150,
        backgroundColor: theme.palette.bgColor.grey100,
        alignSelf: "center",
        padding: "8px",
        borderRadius: "4px",
      }}
    >
      <Typography
        sx={{
          fontFamily: "IranSans",
          fontSize: "12px",
          margin: "auto",
          width: "80%",
        }}
        align="center"
      >
        © 2026 - تمام حقوق برای این نرم افزار محفوظ و متعلق به{" "}
        <a href="https://karentarabarnet.com/" target="_blank">
          <Typography
            sx={{
              fontSize: "12px",
              fontFamily: "IranSans",
            }}
            component="span"
            color="#00A651"
          >
            شرکت کارن ترابر خلیج فارس
          </Typography>{" "}
        </a>
        می‌باشد.
      </Typography>
    </Box>
  );
}
